import { atom } from "jotai";
import { emitEventOnModifyPromptSetter } from "@zapier/canvas-state";

import { isModifyPromptOpenAtom } from "./isModifyPromptOpenAtom";

export const handleModifyPromptSetter = atom(null, (get, set) => {
  set(isModifyPromptOpenAtom, true);
  set(emitEventOnModifyPromptSetter);
});

handleModifyPromptSetter.debugLabel = "handleModifyPromptSetter";
